import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { OAuthService, AuthConfig } from 'angular-oauth2-oidc';
import { Environment_Service } from "../../../modules/system/services/Environment_Service";
import { OAuth_Service } from "../../../modules/system/services/system/OAuth_Service";

@Injectable()
export class oAuth_Internal_Identity_Guard implements CanActivate {

  /* The constructor and canActivate share one discovery / code exchange, an authorization code can only be redeemed once */
  private login_Promise: Promise<boolean>;

  constructor(private oAuthService: OAuthService, private Environment_Service: Environment_Service, private OAuth_Service: OAuth_Service) {

    var authConfig: AuthConfig = new AuthConfig();
    authConfig.issuer = this.Environment_Service.environment.identity_server;
    /* Absolute, code flow sends redirect_uri again on the token request and it must match the registered one exactly */
    authConfig.redirectUri = new URL(this.Environment_Service.environment.identity_server_login_redirect, window.location.origin).href;
    authConfig.clientId = this.Environment_Service.environment.identity_client_id;
    authConfig.scope = this.Environment_Service.environment.identity_scope;
    this.OAuth_Service.configure_Code_Flow(authConfig);
    this.oAuthService.configure(authConfig);
    this.login_Promise = this.oAuthService.loadDiscoveryDocumentAndTryLogin();
    this.oAuthService.setupAutomaticSilentRefresh();
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {

    return this.login_Promise
      .then(() => {
        if (!this.oAuthService.hasValidAccessToken()) {
          this.oAuthService.initCodeFlow();
        }
        else {
          return this.oAuthService.loadUserProfile().then(() => {
            return this.oAuthService.hasValidAccessToken();
          }, err => {
            if (this.OAuth_Service.logoffIfUnauthorized(err, 'oAuth_Internal_Identity_Guard')) {
              return false;
            }
            throw err;
          });
        }
      });
  }
}
